import { render, staticRenderFns } from "./ProgramPOA.vue?vue&type=template&id=0cdfd780"
import script from "./ProgramPOA.vue?vue&type=script&lang=js"
export * from "./ProgramPOA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports